import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/shared/hooks/use-auth";
import { CompanyDashboard } from "@/modules/company/CompanyDashboard";

export const Route = createFileRoute("/_app/company")({
  component: CompanyRoute,
});

function CompanyRoute() {
  const auth = useAuth();
  const navigate = useNavigate();

  // Sidebar already hides the tab for non-admins, but URL access stays
  // open. Backend endpoints return 403 anyway — this is just a UX nicety
  // so a stale link doesn't leave a half-loaded shell on screen.
  useEffect(() => {
    if (!auth.loading && auth.user && auth.user.role !== "admin") {
      navigate({ to: "/" });
    }
  }, [auth.loading, auth.user, navigate]);

  if (auth.loading || auth.user?.role !== "admin") return null;
  return <CompanyDashboard />;
}
